import { render, staticRenderFns } from "./customerWorkOrderDetail.vue?vue&type=template&id=42373ee3&scoped=true"
import script from "./customerWorkOrderDetail.vue?vue&type=script&lang=js"
export * from "./customerWorkOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./customerWorkOrderDetail.vue?vue&type=style&index=0&id=42373ee3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42373ee3",
  null
  
)

export default component.exports